import { render } from "./AboutHeader.vue?vue&type=template&id=67799c3e&scoped=true"
import script from "./AboutHeader.vue?vue&type=script&lang=js"
export * from "./AboutHeader.vue?vue&type=script&lang=js"

import "./AboutHeader.vue?vue&type=style&index=0&id=67799c3e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67799c3e"]])

export default __exports__